// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df5fb14d","726":"c944f308","732":"729fe364","977":"c8ac8f6b"}[chunkId] + ".chunk.js";
};